import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["entries", "pagination", "spinner"]
  static values = { loading: Boolean }

  initialize() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.loadingValue) this.loadMore()
        })
      },
      { rootMargin: "400px" }
    )
  }

  // Observe the sentinel every time it (re)enters the DOM. Each page load
  // turbo_stream-`replace`s the `*_pagination` node with a fresh one, so
  // observing only once on connect left the IntersectionObserver watching the
  // detached old node — pages 2+ never triggered and the feed/profile stuck at
  // the first page (#589). Stimulus fires this for the initial target too.
  paginationTargetConnected(element) {
    this.observer.observe(element)
  }

  paginationTargetDisconnected(element) {
    this.observer.unobserve(element)
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  async loadMore() {
    const nextLink = this.paginationTarget.querySelector("a[rel='next'], a.page-next")
    if (!nextLink) return

    this.loadingValue = true
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.remove("hidden")

    try {
      const url = new URL(nextLink.href)
      url.searchParams.set("format", "turbo_stream")

      const response = await fetch(url, {
        headers: {
          Accept: "text/vnd.turbo-stream.html",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      if (response.ok) {
        Turbo.renderStreamMessage(await response.text())
      }
    } catch (e) {
      console.error("Infinite scroll error:", e)
    } finally {
      this.loadingValue = false
      if (this.hasSpinnerTarget) this.spinnerTarget.classList.add("hidden")
    }
  }
}
